import { jsx, jsxs } from "react/jsx-runtime";
import React from "react";
import withEditorProps from "../withEditorProps";
import { TgSelect, getKeyedTagsAndTagOptions } from "@teselagen/ui";
import { flatMap } from "lodash-es";
import { uniqBy } from "lodash-es";
export const PartTagSearch = withEditorProps(PartToolDropdown);
function PartToolDropdown({
  sequenceData,
  updateSelectedPartTags,
  selectedPartTags,
  allPartTags,
  annotationVisibilityShow,
  editTagsLink,
  dontAutoOpen
}) {
  if (!sequenceData) return /* @__PURE__ */ jsx("div", { children: "No Parts Present" });
  const keyedTags = getKeyedTagsAndTagOptions(allPartTags);
  const tags = uniqBy(
    flatMap(sequenceData.parts, ({ tags: tags2 }) => {
      return flatMap(tags2, (t) => {
        const tag = keyedTags[t];
        if (!tag) return [];
        return tag;
      });
    }),
    "value"
  );
  return /* @__PURE__ */ jsxs("div", { style: { width: "100%" }, children: [
    /* @__PURE__ */ jsx("div", { children: "Search Parts By Tag: " }),
    /* @__PURE__ */ jsxs("div", { style: { display: "flex" }, children: [
      /* @__PURE__ */ jsx(
        TgSelect,
        {
          value: selectedPartTags.parts,
          onChange: (...args) => {
            annotationVisibilityShow("parts");
            updateSelectedPartTags(...args);
          },
          isTagSelect: true,
          multi: true,
          popoverProps: {
            usePortal: false,
            modifiers: {
              preventOverflow: { enabled: false },
              hide: {
                enabled: false
              },
              flip: {
                boundariesElement: "viewport"
              }
            }
          },
          options: tags,
          autoOpen: !dontAutoOpen
        }
      ),
      editTagsLink || null
    ] })
  ] });
}
